'use client';

import { CalculatorId, type CalculatorConfig, CalculatorType } from '../../../lib/calculators/calculator-config';
import { barGraphConfig } from '../bar-graph/bar-graph.config';
import { TableDataJSON } from '../../../src/types/table-json';

export const stackedBarGraphConfig: CalculatorConfig<CalculatorId.StackedBarChart> = {
  ...barGraphConfig,
  id: CalculatorId.StackedBarChart,
  type: CalculatorType.Graph,
  name: 'Stacked Bar Chart',
  initialData: TableDataJSON.from({
    columns: [
      { id: 'department', name: 'Department', values: ['Engineering', 'Marketing', 'Sales', 'Support'] },
      { id: 'revenue', name: 'Revenue', values: ['150', '120', '180', '90'] },
      { id: 'profit', name: 'Profit', values: ['45', '30', '60', '25'] }
    ]
  }),
  initialControlValues: {
    category: 'department',
    values: ['revenue', 'profit'],
    barLayout: 'stacked',
    orientation: 'vertical',
    title: 'Department Revenue and Profit',
    barWidth: 40,
    enableShadow: 'true'
  }
};